module.exports = __webpack_public_path__ + "964dc23f5ffd721c893a503fd70ea8ed.png";